export default (block) => {
  if (block.form.length) {
    // current requirement is that RevealingHero can not have more than one form, so we are only checking the first item in an array
    switch (block.form[0].component) {
      case 'MarketoForm':
        block.marketoFormProps = block.form[0]
        break
      case 'SimpleEmailLink':
        block.simpleEmailLinkProps = block.form[0]
        break
      case 'SiteForm':
        block.emailForm = block.form[0]
        break
    }
  }

  return block
}
